import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  IonBackButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonLabel,
  IonPage,
  IonRow,
  IonSegment,
  IonSegmentButton,
  IonText,
  IonTitle,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";

import { User } from "../../@types/user";
import { Profile } from "../../@types/profile";
import { LocationsSelector } from "./components/LocationsSelector";
import { LocationsSelected } from "./components/LocationsSelected";
import { RootState } from "../../store/rootReducer";
import { findLocations } from "../../store/userProfileLocation/actions/findLocations";
import { findOrganizations } from "../../store/organizations/actions/findOrganizations";
import { findProfileLocations } from "../../store/userProfileLocation/actions/findProfileLocations";
import { setInitialData, setProfile, setUser } from "../../store/userProfileLocation";
import { AssignLocationsStatus } from "./components/AssignLocationsStatus";

export const UserProfileLocation: React.FC = () => {
  const [selectorActive, setSelectorActive] = useState<boolean>(true);
  const dispatch = useDispatch();
  const { id }: { id: string } = useParams();
  const profile: Profile = useSelector((state: RootState) => state.profileDetail.profile);
  const usersList: User[] = useSelector((state: RootState) => state.profileDetail.userList);
  const user = usersList.filter((infoUser) => infoUser.id == id)[0];

  useEffect(() => {
    dispatch(setInitialData());
    dispatch(findLocations()); // Carga inicial de todos los locations
    dispatch(findOrganizations()); // Para filtro por Clientes
    dispatch(findProfileLocations({userId: id, profileId: profile.id})); // Busca los locations seleccionados o asignados al usuario
    dispatch(setUser(user)); // Asigna el usuario actual al store (Necesario para crear nuevos UserProfileLocations)
    dispatch(setProfile(profile)); //Asigna el profile al store (Necesario para crear nuevos UserProfileLocations)
  }, [dispatch, user, profile])

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              text={isPlatform("ios") ? "Usuarios" : ""}
              defaultHref={`/app/tic/perfiles/detalle/${profile.id}`}
              color="light"
            />
          </IonButtons>
          <IonTitle>Asignar plantas al perfil</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense" class="ion-no-border">
          <IonToolbar>
            <IonTitle size="large">Asignar plantas al perfil</IonTitle>
          </IonToolbar>
        </IonHeader>
        <section
          className={isPlatform("desktop") ? "ion-margin" : "ion-no-margin ion-margin-vertical"}
        >
          <IonText color="primary">
            <h2>{profile ? `Perfil ${profile.name}` : "Perfil"}</h2>
          </IonText>
          <IonText color="primary">
            {user ? <h3>{user.name}</h3> : <h3></h3>}
          </IonText>
          <IonGrid class="ion-no-margin ion-no-padding">
            {/* Inicio - Para móviles */}
            <IonRow className="ion-hide-md-up">
              <IonSegment
                value={selectorActive ? "disponibles" : "seleccionados"}
                color="secondary"
                style={{ maxWidth: '100%', position: 'fixed', bottom: 0, left: 0, backgroundColor: 'white', zIndex: 1000 }}
              >
                <IonSegmentButton value="disponibles" onClick={() => { setSelectorActive(true) }}>
                  <IonLabel>Disponibles</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="seleccionados" onClick={() => { setSelectorActive(false) }}>
                  <IonLabel>Seleccionados</IonLabel>
                </IonSegmentButton>
              </IonSegment>
              <IonCol style={{ paddingLeft: 0, paddingRight: 6 }}>
                {selectorActive ? (
                  <LocationsSelector />
                ) : (
                  <LocationsSelected />
                )}
              </IonCol>
              <IonFooter style={{ height: '2rem' }} className="ion-no-border">
              </IonFooter>
            </IonRow>
            {/* Fin - Para móviles */}
            {/* Inicio - para desktop */}
            <IonRow className="ion-hide-md-down">
              <IonGrid class="ion-no-margin ion-no-padding">
                <IonRow>
                  <IonCol size="6" style={{ paddingLeft: 0, paddingRight: 6 }}>
                    <LocationsSelector />
                  </IonCol>
                  <IonCol size="6" style={{ paddingRight: 0, paddingLeft: 6 }}>
                    <LocationsSelected />
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonRow>
            {/* Fin - Para desktop */}
          </IonGrid>  
        </section>
        <AssignLocationsStatus />
      </IonContent>
    </IonPage>
  );
}